__turbopack_context__.v({
  "hasFocus": "text-area-module__Nb8ZbG__hasFocus",
  "input": "text-area-module__Nb8ZbG__input" + " " + __turbopack_context__.i(79883)["input"],
  "resizable": "text-area-module__Nb8ZbG__resizable",
});
